export default "__VITE_ASSET__Bmd9uoXS__"